import * as React from 'react';
import { SvgIcon } from '../../icons/SvgIcon';

interface IProps {
	className?: string;
}

export const AIDADialsIcon: React.FC<IProps> = props => {
	const { className } = props;
	return (
		<SvgIcon className={`aida-dials-icon ${className || ''}`} height={689} width={689}>
			<defs>
				<radialGradient cx='50%' cy='50%' fx='50%' fy='50%' r='50%' id='aida-dials-icon-gradient'>
					<stop stopColor='#00D5F5' offset='0%' />
					<stop stopColor='#00AAE8' offset='100%' />
				</radialGradient>
			</defs>
			<g fill='none' fillRule='evenodd'>
				<circle fill='url(#aida-dials-icon-gradient)' cx='344.5' cy='344.5' r='344.5' />
				<g transform='translate(147 203)'>
					<path
						d='m53.601 140.985-32.924 28.373h32.924l-24.693 24.32h32.924c9.829 26.673 20.804 44.237 32.924 52.693 12.12 8.455 34.07 13.86 65.848 16.213l28.809-32.427L74.179 128.825 53.6 140.985Z'
						fill='#FFF'
					/>
					<path
						d='m146.856 317.56-24.769-24.88c-3.747-3.769-9.848-3.769-13.604-.018L86.47 314.635 38.43 266.68l22.041-22.003c3.747-3.74 3.757-9.812.01-13.562L35.693 206.33a9.62 9.62 0 0 0-13.595 0L.038 228.342 0 228.313c0 68.866 55.918 124.688 124.902 124.688l21.935-21.897a9.572 9.572 0 0 0 .02-13.543'
						fill='#063E66'
					/>
					<path
						d='M345.076 140.985 378 169.358h-32.924l24.693 24.32h-32.924c-9.829 26.673-20.804 44.237-32.924 52.693-12.12 8.455-34.07 13.86-65.848 16.213l-28.809-32.427 115.234-101.332 20.578 12.16Z'
						fill='#FFF'
					/>
					<ellipse fill='#063E66' cx='206.783' cy='230.383' rx='57.072' ry='56.971' />
					<path
						d='M234.083 272.484c-6.936 11.85-19.898 19.824-34.744 19.824-14.847 0-27.81-7.973-34.745-19.824Z'
						fill='#F89143'
					/>
					<rect fill='#E78236' x='65.342' y='24.79' width='277.918' height='183.299' rx='19' />
					<g fill='#FFA25C'>
						<path d='M102.506 148.641H191.8c6.904 0 12.5 5.597 12.5 12.5v52.635c0 6.903-5.596 12.5-12.5 12.5a12.5 12.5 0 0 1-1.524-.093l-74.899-9.202a12.5 12.5 0 0 1-10.34-8.474L90.64 165.074c-2.172-6.553 1.379-13.626 7.932-15.798a12.5 12.5 0 0 1 3.933-.635ZM306.097 148.641H216.8c-6.903 0-12.5 5.597-12.5 12.5v52.635c0 6.903 5.597 12.5 12.5 12.5a12.5 12.5 0 0 0 1.525-.093l74.898-9.202a12.5 12.5 0 0 0 10.341-8.474l14.397-43.433c2.172-6.553-1.38-13.626-7.932-15.798a12.5 12.5 0 0 0-3.933-.635Z' />
					</g>
					<path fill='#063E66' d='M169.562 158.55h64.516L217.1 184.026l-13.582 4.246-13.583-4.246z' />
					<g transform='translate(154.673 44.606)' fill='#063E66'>
						<rect width='94.294' height='20.642' rx='2' />
						<rect x='11.787' y='28.899' width='74.649' height='20.642' rx='2' />
					</g>
					<path
						d='m304.193 141.132 28.169-16.234a2 2 0 0 1 2.73.731l4.085 7.064a2 2 0 0 1-.732 2.734l-28.17 16.235a2 2 0 0 1-2.73-.732l-4.085-7.063a2 2 0 0 1 .733-2.735ZM304.193 161.39l28.169-16.235a2 2 0 0 1 2.73.732l4.085 7.064a2 2 0 0 1-.732 2.734l-28.17 16.234a2 2 0 0 1-2.73-.731l-4.085-7.064a2 2 0 0 1 .733-2.734ZM99.578 137.08l-28.17-16.234a2 2 0 0 0-2.73.732l-4.084 7.063a2 2 0 0 0 .73 2.733l.002.002 28.169 16.234a2 2 0 0 0 2.73-.731l4.085-7.064a2 2 0 0 0-.732-2.734ZM99.578 157.338l-28.17-16.234a2 2 0 0 0-2.73.731l-4.084 7.064a2 2 0 0 0 .732 2.734l28.169 16.235a2 2 0 0 0 2.73-.732l4.085-7.063a2 2 0 0 0-.732-2.735Z'
						fill='#063E66'
					/>
					<g transform='translate(253.868 183.32)' fill='#063E66'>
						<rect x='.094' width='114.113' height='8.398' rx='2' />
						<path d='M3.533 12.67 95.92 29.454a2 2 0 0 1 1.614 2.305l-.74 4.327a2 2 0 0 1-2.33 1.63L2.078 20.934a2 2 0 0 1-1.614-2.305l.741-4.328a2 2 0 0 1 2.329-1.63ZM6.023 28.723l68.57 27.118a2 2 0 0 1 1.139 2.559l-1.525 4.09a2 2 0 0 1-2.61 1.162L3.028 36.533a2 2 0 0 1-1.138-2.558l1.524-4.09a2 2 0 0 1 2.61-1.162Z' />
					</g>
					<g transform='matrix(-1 0 0 1 154.734 183.32)' fill='#063E66'>
						<rect x='.094' width='114.113' height='8.398' rx='2' />
						<path d='M3.533 12.67 95.92 29.454a2 2 0 0 1 1.614 2.305l-.74 4.327a2 2 0 0 1-2.33 1.63L2.078 20.934a2 2 0 0 1-1.614-2.305l.741-4.328a2 2 0 0 1 2.329-1.63ZM6.023 28.723l68.57 27.118a2 2 0 0 1 1.139 2.559l-1.525 4.09a2 2 0 0 1-2.61 1.162L3.028 36.533a2 2 0 0 1-1.138-2.558l1.524-4.09a2 2 0 0 1 2.61-1.162Z' />
					</g>
					<path
						fill='#FFF'
						d='m164.599 267.538 9.925-24.77 9.926 24.77zM214.227 267.538l9.926-24.77 9.925 24.77zM238.178 148.641l90.194-64.198c-35.531-8.024-61.496-6.687-77.895 4.013-16.399 10.7-20.498 30.761-12.299 60.185Z'
					/>
					<g transform='translate(234.078 94.147)'>
						<path
							d='M31.838 66.55C4.054 65.41.078 73.4.024 66.55c-.054-6.848 0-23.35 0-31.961 0-17.653 14.244-31.963 31.814-31.963 8.893 0 26.041-5.91 31.815 0 3.653 3.74-5.386 12.407-6.6 20.415-.658 4.339 2.623 8.484 2.623 11.548 0 17.652-10.28 32.683-27.838 31.962Z'
							fill='#063E66'
						/>
						<ellipse
							fill='#F84343'
							transform='matrix(-1 0 0 1 55.83 0)'
							cx='27.915'
							cy='37.442'
							rx='15.907'
							ry='15.981'
						/>
					</g>
					<path
						d='M160.499 148.641 70.305 84.443c35.531-8.024 61.496-6.687 77.895 4.013 16.399 10.7 20.498 30.761 12.299 60.185Z'
						fill='#FFF'
					/>
					<path
						d='M275.739 22.982c16.302-.829 28.502-2.611 36.601-5.349 8.1-2.737 18.373-8.55 30.82-17.438 10.376 35.852 3.554 56.97-20.466 63.355-24.02 6.385-39.672-7.138-46.955-40.568Z'
						fill='#063E66'
					/>
					<path
						d='M276.032 20.365c14.08-.733 24.62-2.273 31.62-4.62 6.998-2.348 15.88-7.321 26.644-14.92 8.907 30.553 2.983 48.572-17.772 54.055-20.755 5.483-34.252-6.022-40.492-34.515Z'
						fill='#F89143'
					/>
					<path
						d='M117.976 22.982c-16.303-.829-28.503-2.611-36.602-5.349C73.274 14.896 63 9.083 50.554.195 40.178 36.047 47 57.165 71.02 63.55c24.02 6.385 39.672-7.138 46.956-40.568Z'
						fill='#063E66'
					/>
					<path
						d='M117.682 20.365c-14.08-.733-24.62-2.273-31.62-4.62-6.998-2.348-15.88-7.321-26.643-14.92-8.907 30.553-2.984 48.572 17.771 54.055 20.755 5.483 34.252-6.022 40.492-34.515Z'
						fill='#F89143'
					/>
					<ellipse fill='#063E66' cx='181.969' cy='195.704' rx='2.481' ry='2.477' />
					<ellipse fill='#063E66' cx='167.08' cy='210.567' rx='2.481' ry='2.477' />
					<g transform='matrix(-1 0 0 1 244.004 193.227)' fill='#063E66'>
						<ellipse cx='20.678' cy='4.954' rx='4.136' ry='4.954' />
						<ellipse cx='4.136' cy='14.862' rx='4.136' ry='4.954' />
					</g>
					<g transform='matrix(-1 0 0 1 164.599 94.147)'>
						<path
							d='M31.838 66.55C4.054 65.41.078 73.4.024 66.55c-.054-6.848 0-23.35 0-31.961 0-17.653 14.244-31.963 31.814-31.963 8.893 0 26.041-5.91 31.815 0 3.653 3.74-5.386 12.407-6.6 20.415-.658 4.339 2.623 8.484 2.623 11.548 0 17.652-10.28 32.683-27.838 31.962Z'
							fill='#063E66'
						/>
						<ellipse
							fill='#F84343'
							transform='matrix(-1 0 0 1 55.83 0)'
							cx='27.915'
							cy='37.442'
							rx='15.907'
							ry='15.981'
						/>
					</g>
				</g>
			</g>
		</SvgIcon>
	);
};
